import { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useMeasure } from 'react-use';
export const useOverflowBreadcrumbItems = items => {
  const containerRef = useRef(null);
  const [measureRef, {
    width
  }] = useMeasure();
  const [visibleItems, setVisibleItems] = useState(items);
  const [hasOverflow, setHasOverflow] = useState(false);
  const [previousWidth, setPreviousWidth] = useState(0);
  const checkOverflow = useCallback(() => {
    const container = containerRef.current;
    if (!container) {
      return;
    }
    if (container.clientWidth > previousWidth) {
      setVisibleItems(items);
    }
    setPreviousWidth(container.clientWidth);
    const MIN_VISIBLE_ITEMS = 1;
    if (container.scrollWidth > container.clientWidth && visibleItems.length >= MIN_VISIBLE_ITEMS) {
      setHasOverflow(true);
      const newArr = visibleItems.slice(1);
      setVisibleItems(newArr);
    } else if (items.length === visibleItems.length) {
      setHasOverflow(false);
    }
  }, [items, previousWidth, visibleItems]);

  // reset the previous width state after breadcrumbs change
  useEffect(() => {
    setVisibleItems(items);
    setPreviousWidth(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items.map(item => item.label).join('')]);
  useLayoutEffect(() => {
    if (containerRef.current) {
      measureRef(containerRef.current);
    }
  }, [measureRef]);
  useLayoutEffect(() => {
    if (width) {
      checkOverflow();
    }
  }, [width, checkOverflow]);
  return {
    containerRef,
    visibleItems,
    hasOverflow
  };
};